module.exports = __webpack_public_path__ + "static/media/T12_Frame_Wooden_DK Oak.be2d7b19.png";